import styles from './UIGameRotateDevice.module.scss';
import React from 'react';
import { NonDismissibleOverlay, T } from '@colonist/ui';
import IconRotatePhone from '@static/images/icon_rotate_phone.png';
export function UIGameRotateDevice() {
    return /*#__PURE__*/ React.createElement(NonDismissibleOverlay, {
        backgroundOpacity: "opaque"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: styles.title
    }, /*#__PURE__*/ React.createElement(T, {
        id: "strings:popups.rotateDevice.title"
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.content
    }, /*#__PURE__*/ React.createElement("img", {
        src: IconRotatePhone,
        className: styles.image
    }), /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement(T, {
        id: "strings:popups.rotateDevice.description"
    }))));
}
